module.exports = __webpack_public_path__ + "static/media/wateringcanleft.cf972605.png";